export const projects = {
  webPlatform: 'webPlatform',
  selfserve: 'selfserve',
  vymoWeb: 'vymoWeb',
};
